import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element } from 'common/types/tracking';

export const trackNavigationLinkClick = (label: string, position: number, length: number) => {
  dispatchTrackingEventGA4({
    event: 'global-header-nav-link_click',
    element: Element.Button,
    clicked_text: label,
    list_position: position,
    list_length: length,
  });
};
